var $ = require('jquery');

$(function () {
    if ($("[data-ws-dialog-content='#share-link-dialog']").length > 0) {
        $.getScript('https://platform-api.sharethis.com/js/sharethis.js#property=5a1ebf41c87cd900112f818b&product=sop');
    }
});